import script from "./ClientProjectRealTimePlot.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientProjectRealTimePlot.vue?vue&type=script&setup=true&lang=js"

import "./ClientProjectRealTimePlot.vue?vue&type=style&index=0&id=33908bd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33908bd0"]])

export default __exports__